export default __webpack_public_path__ + "static/Outlook-Contacts-hero-1-d5e1fc7276254f077f12178654d7e3f7.webp";